'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getEnv = function getEnv() {
  return window.location.host === 'www.quantcast.com' ? 'production' : 'test';
};

var PATHS = exports.PATHS = {
  test: 'https://static-test.quantcast.com/gn/',
  production: 'https://static.quantcast.com/gn/',
  local: 'http://localhost:8080/src/'
};

var CONFIG = exports.CONFIG = {
  env: getEnv(),
  footer: false,
  gtm: true
};

var STORE_NAME = exports.STORE_NAME = 'qcContext';

var DOM_CLASSES = exports.DOM_CLASSES = {
  bodyNoScroll: 'body--no-scroll',
  mask: '.mask',
  maskFlyoutOpen: 'mask--flyout',
  maskAccountSelectorOpen: 'mask--selector',
  nav: 'nav.nav',
  navSearching: 'nav--searching',
  flyout: '.flyout',
  flyoutOpen: 'flyout--open',
  flyoutBtn: '.nav__actions__flyout',
  searchBtn: '.nav__actions__search',
  searchTopSites: '.nav__search__button',
  searchForm: '.nav__search',
  searchInput: '.nav__search__input',
  userInfo: '.nav__user-info',
  userInfoOpen: 'nav__user-info--showing',
  userInfoBtn: '.nav__actions__account',
  sections: '.nav__list__item__link',
  headerPlaceholder: '.nav--placeholder',
  accountSelector: '.selector--accounts',
  accountSelectorOpen: 'selector--active',
  accountSelectorBtn: '.nav__selector',
  accountSelectorBtnDisabled: 'nav__selector--disabled',
  accountSelectorExit: '.selector--accounts .selector__exit',
  accountSelectorItem: '.selector--accounts .selector__content__list__items__item',
  accountSelectorSearchInput: '.selector__content__list__search__input'
};

var DOM_IDS = exports.DOM_IDS = {
  header: '#globalHeader',
  footer: '#globalFooter'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/qc-global-navigation/src/constants.js
// module id = 23
// module chunks = 0